<template>
  <div style="margin: 0px 0px 0px 0px">
    <v-data-table :items="weekdays"
                  hide-actions
                  class="noPadding"
                  hide-headers>
      <template slot="items"
                slot-scope="props">
        <td>
          <span style="margin-left: 50px">
            {{ props.item.label }}
          </span>
        </td>
        <td class="text-xs-right">
          <v-chip v-for="(schedule, index) in props.item.schedule"
                  :key="`${schedule.key}_${index}`"
                  disabled
                  outline
                  color="accent">
            <span v-if="schedule.text === 'private_parking_products_allDay'">{{ $t(schedule.text) }}</span>
            <span v-else>{{ schedule.text }}</span>
          </v-chip>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'ScheduleViewer',
  props: ['weekdays']
};
</script>

<style scoped>
.noPadding table.v-table tbody td {
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/ScheduleViewer.vue